export default class IconsNumberOfPath {
    static SELECTION_TICK_SELECTED = 2;
}
